import React, { useContext, useEffect, useState } from 'react';
// import { io } from 'socket.io-client';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import Page from '../../layout/Page/Page';
import Humans from '../../assets/img/scene2.png';
import HumansWebp from '../../assets/img/scene2.webp';
import Humans4 from '../../assets/img/scene4.png';
import HumansWebp4 from '../../assets/img/scene4.webp';
import { pageLayoutTypesPagesMenu } from '../../menu';
import Card from '../../components/bootstrap/Card';
import { LOKASI, SLOKASI } from '../../common/data/lokasi';
import services from '../../services';
import showNotification from '../../components/extras/showNotification';
import Icon from '../../components/icon/Icon';
import Loader from '../../components/Loader';
import SubHeader, { SubHeaderLeft, SubHeaderRight, SubheaderSeparator } from '../../layout/SubHeader/SubHeader';
import Button, { ButtonGroup, IButtonProps } from '../../components/bootstrap/Button';
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../../components/bootstrap/Dropdown';
import ThemeContext from '../../contexts/themeContext';
import Popovers from '../../components/bootstrap/Popovers';
import useDarkMode from '../../hooks/useDarkMode';
import Alert from '../../components/bootstrap/Alert';

const PollingPage = () => {
    const { darkModeStatus, setDarkModeStatus } = useDarkMode();
    const pollingValue = [
        { label: 'Sangat Puas', value: 5, icon: '😊' },
        { label: 'Puas', value: 4, icon: '😊' },
        { label: 'Kurang', value: 2, icon: '😐' },
        { label: 'Sangat Kurang', value: 1, icon: '😞' }
    ];
    
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isPolling, setIsPolling] = useState(1);
	const [isAdmin, setIsAdmin] = useState(0);
	const [isDonatur, setIsDonatur] = useState(0);
    const [activeLokasi, setActiveLokasi] = useState<SLOKASI>(LOKASI.BEIJI);
    const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
    const styledBtn: IButtonProps = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};
    
    // useEffect(() => {
    //     
    //    const socket = io(`${process.env.REACT_APP_BASE_URL_SOCKET}`);
    //     socket.on("connect", () => {
    //         console.log("✅🔗Connected to the server");
    //     })
    //     socket.on("connect_error", (err) => {
    //         console.log(`connect_error due to ${err.message}`);
    //     });
    //     socket.on("set-polling-kepuasan", (msg: any) => {
    //         try {
    //             const parsedMsg = JSON.parse(msg);
    //             if (parsedMsg.lokasi === activeLokasi) {
    //                 setIsPolling(2);
    //                 setIsAdmin(parsedMsg.user);
    //                 setIsDonatur(parsedMsg.donatur_id)
    //             }
    //         } catch (error) {
    //             console.error("Failed to parse message:", error);
    //         }
    //     });
    //     socket.on("disconnect", () => {
    //         console.log("🔗disconnected to the server");
    //     })
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);
    async function handleClik(val: any) {
        const value = {
            "object": "vote",
            "donatur_id": isDonatur,
            "nilai": val,
            "created_at": isAdmin
        }
        const response = await services.general.create('vote', value);
        if (response.data.statcode === 0) {
            showNotification(
                '',
                <div className='row d-flex align-items-center'>
                    <div className='col-auto'>
                        <Icon icon='CheckCircle' className='h1' />
                    </div>
                    <div className='col-auto h5'>{response.data.message}</div>
                </div>,
                'info',
            );
            setIsLoading(false);
            setIsPolling(3);
        } else {
            showNotification(
                '',
                <div className='row d-flex align-items-center'>
                    <div className='col-auto'>
                        <Icon icon='Error' className='h1' />
                    </div>
                    <div className='col-auto h5'>
                        {response.data.message[0].message
                            ? response.data.message[0].message
                            : response.data.message}
                    </div>
                </div>,
                'danger',
            );
        }
	}
    const [countdown, setCountdown] = useState<number>(20);

    // Effect untuk mengelola hitung mundur
    useEffect(() => {
        let timer: NodeJS.Timeout;

        // Memulai hitung mundur jika isPolling bernilai 2 atau 3
        if (isPolling === 2 || isPolling === 3) {
            setCountdown(20); // Reset waktu hitung mundur
            timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setIsPolling(1);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => {
            clearInterval(timer);
        };
    }, [isPolling]);
	return (
		<PageWrapper title='survey kepuasan' isProtected={false}>
            <SubHeader>
				<SubHeaderLeft>
					<span className='h4 mb-0 fw-bold'>Overview</span>
					<SubheaderSeparator />
                    <div className='col-auto'>
                        <Popovers trigger='hover' desc='Dark / Light mode'>
                            <Button
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...styledBtn}
                                onClick={() => setDarkModeStatus(!darkModeStatus)}
                                className='btn-only-icon'
                                data-tour='dark-mode'
                                aria-label='Toggle dark mode'>
                                <Icon
                                    icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
                                    color={darkModeStatus ? 'info' : 'warning'}
                                    className='btn-icon'
                                />
                            </Button>
                        </Popovers>
                    </div>
                    <div className='col-auto'>
                        <Popovers trigger='hover' desc='Fullscreen'>
                            <Button
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...styledBtn}
                                icon={fullScreenStatus ? 'FullscreenExit' : 'Fullscreen'}
                                onClick={() => setFullScreenStatus(!fullScreenStatus)}
                                aria-label='Toggle fullscreen'
                            />
                        </Popovers>
                    </div>
				</SubHeaderLeft>
				<SubHeaderRight>
                    {isPolling != 1 && (
                        <Button color='primary' isLight icon='AccessTime'>
                        {countdown} detik
                        </Button>
                    )}
					<Dropdown>
						<DropdownToggle>
							<Button color='primary' isLight icon='GridOn'>
								{activeLokasi}
							</Button>
						</DropdownToggle>
						<DropdownMenu>
                            {Object.keys(LOKASI).map((key) => (
                                <DropdownItem key={key} onClick={() => setActiveLokasi(LOKASI[key])}>
                                    <div>
                                        {LOKASI[key]}
                                    </div>
                                </DropdownItem>
                            ))}
						</DropdownMenu>
					</Dropdown>
				</SubHeaderRight>
			</SubHeader>
			<Page>
            {isLoading && <Loader />}
            {isPolling === 1 && (
                <div className='row d-flex align-items-center h-100'>
                    <div
                        className='col-12 d-flex justify-content-center'
                        style={{ fontSize: 'calc(3rem + 3vw)' }}>
                        <p>
                            <span className='text-danger fw-bold ms-1'>Selamat Datang</span>
                        </p>
                    </div>
                    <div className='col-12 d-flex align-items-baseline justify-content-center'>
                        <img
                            srcSet={HumansWebp}
                            src={Humans}
                            alt='Humans'
                            style={{ height: '50vh' }}
                        />
                    </div>
                </div>
                )}

                {isPolling === 2 && (
                    <div className='row d-flex align-items-center h-100'>
                        <div
                            className='col-12 d-flex justify-content-center'
                            style={{ fontSize: 'calc(3rem + 3vw)' }}>
                            <p>
                                survei <span className='text-dark fw-bold ms-1'>Kepuasan</span>
                            </p>
                        </div>
                        <div className='row'>
                            {pollingValue.map((item, index) => (
                                <div className='col-md-3' key={item.value}>
                                    <Card
                                        className='p-3 text-center shadow-3d-primary cursor-pointer transition-base'
                                        onClick={() => handleClik(item.value)}>
                                        <div className='icon' style={{ fontSize: '2rem' }}>{item.icon}</div>
                                        <h5 className='mt-2'>{item.label}</h5>
                                    </Card>
                                </div>
                            ))}
                        </div>
                        <div className='col-12 d-flex align-items-baseline justify-content-center'>
                            <img
                                srcSet={HumansWebp}
                                src={Humans}
                                alt='Humans'
                                style={{ height: '50vh' }}
                            />
                        </div>
                    </div>
                )}

                {isPolling === 3 && (
                    <div className='row d-flex align-items-center h-100'>
                        <div
                            className='col-12 d-flex justify-content-center'
                            style={{ fontSize: 'calc(3rem + 3vw)' }}>
                            <p>
                                survei <span className='text-dark fw-bold ms-1'>Kepuasan</span>
                            </p>
                        </div>
                        <div
                            className='col-12 d-flex justify-content-center'
                            style={{ fontSize: 'calc(3rem + 3vw)' }}>
                            <p>
                                <span className='text-danger fw-bold ms-1'>Terimakasih</span>
                            </p>
                        </div>
                        <div className='col-12 d-flex align-items-baseline justify-content-center'>
                            <img
                                srcSet={HumansWebp4}
                                src={Humans4}
                                alt='Humans'
                                style={{ height: '50vh' }}
                            />
                        </div>
                    </div>
                )}

			</Page>
		</PageWrapper>
	);
};

export default PollingPage;
